import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'src/store/store';
import { DefaultLayout } from 'src/components/layouts';
import WriteHeader from 'src/modules/community/write/components/writeHeader';
import WritePostEditor from 'src/modules/community/write/components/writePostEditor';
import WritePostEditorAndroid from 'src/modules/community/write/components/writePostEditorAndroid';
import PostExtras from 'src/modules/community/write/components/writePostExtras';
import SpinnerOverlay from 'src/components/spinnerOverlay';
import { showModal } from 'src/modules/shared/modal/actions';
import { ModalType } from 'src/constants/modalTypes';
import { Section } from 'src/constants/footfall';
import { Container } from 'src/modules/community/write/components/sharedStyles';

// Create and edit post
export default function WritePage(): JSX.Element {
  const dispatch = useDispatch();
  const {
    query
  } = useRouter();
  const {
    isLoading
  } = useSelector(state => state.pages.write);
  const slug = useSelector(state => state.context.currentCommunity?.slug);
  const {
    isAndroidUser
  } = useSelector(state => state.context);
  useEffect(() => {
    // a special url with no slug exists (/write) - shows modal where the user chooses a community to redirect to(write to)
    if (!query?.communitySlug) {
      dispatch(showModal({
        modalType: ModalType.SelectCommunityToPost,
        modalProps: {
          section: Section.WritePostChooseCommunity
        }
      }));
    }
  }, [query, dispatch]); // trigger on query so that the modal opens on back navigation

  return <DefaultLayout doClearCommunity={false} fullWidth={true} data-sentry-element="DefaultLayout" data-sentry-component="WritePage" data-sentry-source-file="writePage.tsx">
      {isLoading && <SpinnerOverlay />}
      {slug && <>
          <WriteHeader />
          <Container>
            {!isAndroidUser ? <WritePostEditor>
                <PostExtras />
              </WritePostEditor> : <WritePostEditorAndroid>
                <PostExtras />
              </WritePostEditorAndroid>}
          </Container>
        </>}
    </DefaultLayout>;
}